import { render, staticRenderFns } from "./404.vue?vue&type=template&id=c74f10a8&scoped=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
import style0 from "./404.vue?vue&type=style&index=0&id=c74f10a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74f10a8",
  null
  
)

export default component.exports